import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "@remix-run/react";
import { styled } from 'styled-components';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { svgBasePath } from '../../../../../play-core/utils/base-path';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { usePath, useVideoConfig } from '../../../config/VideoAppContext';
import { useSearchDispatch } from '../../../pages/Search/SearchContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlayLogo = () => {
  const analytics = useAnalyticsDispatch();
  const {
    homePath
  } = usePath();
  const {
    businessUnit,
    meta
  } = useVideoConfig();
  const searchDispatch = useSearchDispatch();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(StyledLink, {
    to: homePath,
    onClick: () => {
      searchDispatch({
        type: 'close'
      });
      analytics({
        type: 'click-event',
        name: 'MainNavigationClick',
        value1: 'Home',
        value2: 'PlayLogo'
      });
    },
    children: /*#__PURE__*/_jsx("span", {
      "aria-label": `${meta.appName}, ${t('global.homepage')}`,
      children: /*#__PURE__*/_jsx(Image, {
        "data-testid": "play-logo",
        alt: meta.appName,
        src: `${svgBasePath}/play-${businessUnit}.svg`
      })
    })
  });
};
export const desktopLogoWidth = 98;
export const mobileLogoWidth = 72;
const StyledLink = styled(Link).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "PlayLogo__StyledLink",
  componentId: "sc-2i8tex-0"
})(["line-height:0;padding-right:20px;cursor:pointer;"]);
const Image = styled.img.withConfig({
  displayName: "PlayLogo__Image",
  componentId: "sc-2i8tex-1"
})(["width:", "px;", "{width:", "px;}"], desktopLogoWidth, Viewports.for('small'), mobileLogoWidth);